import { useDraggable, useDroppable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { makeStyles, tokens } from '@fluentui/react-components';
import { type ReactNode } from 'react';

const useStyles = makeStyles({
  wrap: { position: 'relative' },
  over: {
    outline: `2px dashed ${tokens.colorBrandStroke1}`,
    outlineOffset: '-2px',
    borderRadius: tokens.borderRadiusSmall,
  },
  dragging: { opacity: 0.5 },
});

interface Props {
  folderId: string;
  containerId: string;
  parentId: string | null;
  children: ReactNode;
}

export function DraggableFolder({ folderId, containerId, parentId, children }: Props) {
  const styles = useStyles();
  const { setNodeRef: setDragRef, listeners, attributes, transform, isDragging } = useDraggable({
    id: `folder:${folderId}`,
    data: { type: 'folder', folderId, containerId, parentId },
  });
  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: `folder-drop:${folderId}`,
    data: { type: 'folder', folderId, containerId, parentId },
  });

  const setRef = (node: HTMLDivElement | null) => {
    setDragRef(node);
    setDropRef(node);
  };

  return (
    <div
      ref={setRef}
      {...attributes}
      {...listeners}
      style={{ transform: CSS.Translate.toString(transform) }}
      className={`${styles.wrap} ${isOver ? styles.over : ''} ${isDragging ? styles.dragging : ''}`}
    >
      {children}
    </div>
  );
}
